module.exports = __webpack_public_path__ + "img/hero@3x.c937c301.webp";